export default {
    xs: 600, // tablet_portrait_up
    sm: 900, // tablet_landscape_up
    md: 1200, // desktop_up
    lg: 1800, // lg_desktop_up,
    xl: 2200
};
